import React from "react";
import DownloadReportButton from "../../../../components/common/DownloadReportButton";
import { useBoolean } from "../../../../Hooks/useBoolean";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import { driverSalaryReportApiCall } from "../../../../Api/api";
import { addNumbers, areAllNumbers } from "../../../../helpers";
import {
   calculateDayDifference,
   calculatePayableDays,
   calculateTimeDifference,
   convertHoursToDays,
} from "../../../../helpers/calculateTimeDifference";

const DownloadSalaryReport = () => {
   const dispatch = useDispatch();
   const reportPopup = useBoolean();

   const handleDownloadReport = async (data) => {
      dispatch(backdropLoadingAction(true));

      console.log({ data }, calculateDayDifference(data?.startDate, data?.endDate));
      // return;

      try {
         const res = await driverSalaryReportApiCall(data);
         // console.log({
         //    reportData: res?.data?.res?.map?.((item) => ({
         //       ...item,
         //       trips: typeof item?.trips === "string" ? JSON.parse(item?.trips) : {},
         //    })),
         // });

         const reportData = res?.data?.res?.map?.((item) => {
            let trips = [];

            if (typeof item?.trips === "string" && item.trips.trim() !== "") {
               // Use regex to extract all valid JSON objects
               const tripMatches = item.trips.match(/\{.*?\}/g);

               if (tripMatches) {
                  try {
                     trips = tripMatches.map((trip) => JSON.parse(trip)); // Parse each object
                  } catch (jsonError) {
                     console.error("Failed to parse trips JSON:", jsonError);
                  }
               }
            }

            return {
               ...item,
               trips,
            };
         });

         const headers = [
            "Sl. No.",
            "Driver Name",
            "Mobile No",
            "Vehicle No",
            "Contractor Name",
            "Period",
            "Actual Diesel",
            "Approved Diesel",
            "Monthly Salary",
            "Monthly Salary Commision",
            "Payable Working Days",
            "Diesel Difference",
            "Total Salary",
            "Account Holder Name",
            "A/C No",
            "IFSC No",
            "Detention In Days",
            "Food Expense",
         ];

         const driverMasterDataArr = [];

         reportData?.forEach?.((item, index) => {
            const arr = [];

            const actualDiesel = item?.trips?.reduce((acc, cur) => {
               const val = parseFloat(cur?.actual_diesel_provided);
               return !isNaN(val) ? acc + val : acc;
            }, 0);

            const approvedDiesel = item?.trips?.reduce((acc, cur) => {
               const val = parseFloat(cur?.trip_diesel_budget);
               return !isNaN(val) ? acc + val : acc;
            }, 0);

            const dieselDifference =
               Math.abs(approvedDiesel || 0) - Math.abs(actualDiesel || 0);

            const totalDetentionTime = item?.trips?.reduce((acc, trip) => {
               return (
                  acc +
                  calculateTimeDifference(
                     trip?.destination_unloading_date,
                     trip?.destination_reported_date
                  )
               );
            }, 0);

            const totalDetentionTimeInDays = convertHoursToDays(totalDetentionTime - 24);

            arr.push(
               index + 1 ?? "-", // Sl. No.
               item?.driver_name ?? "-", // Driver Name
               item?.mobile ?? "-", // Mobile No
               item?.driver_license ?? "-", // Vehicle No
               item?.contractor_name ?? "-", // Contractor Name
               item?.period ?? "-", // Period
               actualDiesel ?? "-", // Actual Diesel
               approvedDiesel ?? "-", // Approved Diesel
               item?.driver_monthly_salary_amount ?? "-", // Monthly Salary
               item?.monthly_salary_commission_amount ?? "-", // Monthly Salary Commision
               calculatePayableDays(
                  data?.from_date,
                  data?.to_date,
                  item?.doj,
                  item?.doe
               ) ?? "-", // Payable Working Days
               dieselDifference ?? "-", // Diesel Difference
               areAllNumbers(
                  item?.driver_monthly_salary_amount,
                  item?.monthly_salary_commission_amount
               )
                  ? addNumbers(
                       item?.driver_monthly_salary_amount,
                       item?.monthly_salary_commission_amount
                    )
                  : "-", // Total Salary
               item?.driver_account_holder_name ?? "-", // Account Holder Name
               item?.driver_account_number ?? "-", // A/C No
               item?.driver_ifsc_code ?? "-", // IFSC No
               totalDetentionTimeInDays ?? "-", // Detention In Days
               areAllNumbers(totalDetentionTimeInDays)
                  ? totalDetentionTimeInDays * 300
                  : "-" // Food Expense
            );
            driverMasterDataArr.push(arr);
         });

         // Combine headers and rows
         const sheetData = [headers, ...driverMasterDataArr];

         console.log({ reportData });
         const ws = XLSX.utils.aoa_to_sheet(sheetData);
         ws["!cols"] = new Array(reportData?.length)?.map(() => ({ width: 1500 }));
         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
         XLSX.writeFile(wb, "DRIVER_SALARY_REPORT.xlsx");

         dispatch(backdropLoadingAction(false));
         reportPopup.onFalse();
      } catch (error) {
         console.log({ error });
         dispatch(backdropLoadingAction(false));
      }

      //   dispatch(
      //      driverMasterReportAsync({
      //         data: data,
      //         err: () => {
      //            dispatch(backdropLoadingAction(false));
      //         },
      //         done: (report) => {
      //            const headers = [
      //               "S. No.",
      //               "Driver Name",
      //               "Driver No.",
      //               "Driver License No.",
      //               "Driver License Expiry Date",
      //               "Driver Aadhar No.",
      //               "PAN Card",
      //               "Driver DOB",
      //               "Driver Joining Date",
      //               "Driver Exit Date",
      //               "Driver Address",
      //               "Driver Salary",
      //               "Eisaku Payroll / Contractor",
      //               "Driver Account No.",
      //               "Driver Account IFSC Code",
      //               "Contractor commission amount",
      //               "Driver Experience (Years)",
      //            ];

      //            const driverMasterDataArr = [];

      //            report?.forEach?.((item, index) => {
      //               const arr = [];
      //               arr.push(
      //                  index + 1, // S. No.
      //                  item?.name ?? "-", // Driver Name
      //                  item?.mobile ?? "-", // Driver No.
      //                  item?.driver_license ?? "-", // Driver License No.
      //                  item?.license_expiry_date ?? "-", // Driver License Expiry Date
      //                  item?.aadhar_card ?? "-", // Driver Aadhar No.
      //                  item?.pan_card ?? "-", // PAN Card
      //                  item?.dob ?? "-", // Driver DOB
      //                  item?.doj ?? "-", // Driver Joining Date
      //                  item?.doe ?? "-", // Driver Exit Date
      //                  item?.address ?? "-", // Driver Address
      //                  item?.driver_monthly_salary_amount ?? "-", // Driver Salary
      //                  item?.payroll ?? "-", // Eisaku Payroll / Contractor
      //                  item?.driver_account_number ?? "-", // Driver Account No.
      //                  item?.driver_ifsc_code ?? "-", // Driver Account IFSC Code
      //                  item?.monthly_salary_commission_amount ?? "-", // Contractor commission amount
      //                  item?.experience ?? "-" // Driver Experience (Years)
      //               );
      //               driverMasterDataArr.push(arr);
      //            });

      //            console.log({ driverMasterDataArr });

      //            // Combine headers and rows
      //            const sheetData = [headers, ...driverMasterDataArr];

      //            console.log({ report });
      //            const ws = XLSX.utils.aoa_to_sheet(sheetData);
      //            ws["!cols"] = new Array(report?.length)?.map(() => ({ width: 1500 }));
      //            const wb = XLSX.utils.book_new();
      //            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      //            XLSX.writeFile(wb, "DRIVER_MASTER_REPORT.xlsx");
      //            dispatch(backdropLoadingAction(false));
      //            reportPopup.onFalse();
      //         },
      //      })
      //   );
   };

   return (
      <DownloadReportButton
         onDownloadReport={handleDownloadReport}
         confirmPopup={reportPopup}
         title="Download Salary Report"
      />
   );
};

export default DownloadSalaryReport;
